import React from "react"
import { Users, UserCheck, Share2, Megaphone, Building2, QrCode } from "lucide-react"
import { Badge } from "src/components/ui/badge"

const SOURCE_CONFIG = {
  channel_partner: { label: "Channel Partner", Icon: Users },
  direct:          { label: "Direct",           Icon: UserCheck },
  referral:        { label: "Referral",          Icon: Share2 },
  campaign:        { label: "Campaign",          Icon: Megaphone },
  walk_in:         { label: "Walk-in",           Icon: Building2 },
  qr_campaign:     { label: "QR Campaign",       Icon: QrCode },
}

export function LeadSourceBadge({ source }) {
  if (!source) return <span className="text-slate-400 text-xs">—</span>
  const config = SOURCE_CONFIG[source]
  if (!config) return null
  const { label, Icon } = config

  return (
    <Badge variant="secondary" className="gap-1 font-normal text-slate-600">
      <Icon className="h-3 w-3" />
      {label}
    </Badge>
  )
}

export { SOURCE_CONFIG }
